<template>
	<div>
		<div>
			<el-form :inline="true" ref="queryForm" :model="queryForm">
				<el-form-item>
					<el-input v-model="queryForm.name" placeholder="岗位"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button icon="el-icon-search" @click="list" type="danger">查询</el-button>
					<el-button icon="el-icon-plus" @click="add" type="primary">新增</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-table :data="tableData" :max-height="tableHeight">
			<el-table-column prop="name" label="岗位" min-width="100" :show-overflow-tooltip="true">
				<template slot-scope="scope">
						{{scope.row.name}}
				</template>
			</el-table-column>
			<el-table-column prop="address" label="地点" min-width="100">
				<template slot-scope="scope">
						{{scope.row.address}}
				</template>
			</el-table-column>
			<el-table-column prop="type" label="招聘类型" min-width="100"></el-table-column>
			<el-table-column prop="content" label="岗位介绍" min-width="300"></el-table-column>
			<el-table-column prop="publish" label="上传时间" min-width="100"></el-table-column>
			<el-table-column align="center" label="操作" min-width="100">
				<template slot-scope="scope">
					<el-link @click="edit(scope.row)" :underline="false" type="primary" class="el-icon-edit-outline">编辑</el-link>
					<span style="display: inline-block;width: 20px;"></span>
					<el-link @click="del(scope.row)" :underline="false" type="danger" class="el-icon-delete">删除</el-link>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination background layout="total,prev, pager, next,jumper" @current-change="handleCurrentChange"
			:current-page="pageNo" :total="total">
		</el-pagination>
		<el-image-viewer v-if="showViewer" :on-close="closeImg" :url-list="srcList" />
	</div>
</template>

<script>
	import {queryTreeChannelByPid} from '@/api/channel'
	import ElImageViewer from "element-ui/packages/image/src/image-viewer";
	import {del,query} from "@/api/joinUs";
	import token from "@/token.js";

	export default {
		name: "Index",
		components: {
			ElImageViewer
		},
		data() {
			return {
				queryForm: {
					name: ''
				},
				tableData: [],
				treeData: [],
				total: 0,
				pageNo: 1,
				defForm: {
					id:0,
					updateUserID: token.getUser().id,
					updateUserName: token.getUser().manager_username
				},
				showViewer:false,
				srcList:[],
				tableHeight:500
			}
		},
		
		mounted() {
			this.list()
			this.$nextTick(() => {
        const height = window.innerHeight
        this.tableHeight = height-230
      })
			queryTreeChannelByPid(12).then(data => {
				this.treeData = data.data
				console.log(this.treeData)
			}).catch(error => {

			})
		},
		methods: {
			closeImg(){
				this.showViewer = false
			},
			showImage(img){
				this.showViewer = true
				let srcList = []
				srcList.push(img)
				this.srcList = srcList
			},
			//改变当前页
			handleCurrentChange(val) {
				this.pageNo = val;
				this.list()
			},
			//查询栏目列表
			list() {
				let param = {
					name: this.queryForm.name,
					page: this.pageNo,
					pageSize: 10,
				}
				query(param).then(data => {
					this.tableData = data.data.list
					this.total = data.data.total
					// console.log("列表",this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
			add() {
				this.$router.push('/adminIndex/joinUs_add')
			},
			edit(row) {
				this.$router.push({
					path: '/adminIndex/joinUs_edit',
					query: {
						obj: row
					}
				})
			},
			del(row) {
				this.defForm.id=row.id
			
				this.$confirm('确定要删除吗？', "提示", {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					del(this.defForm).then(data => {
						let totalPage = Math.ceil((this.total - 1) / 10); //15 是每页15条
						let pageNo = this.pageNo > totalPage ? totalPage : this.pageNo;
						this.pageNo = pageNo < 1 ? 1 : pageNo; //this.pageNo 当前页数
						this.list()
						this.$message.success("删除成功!")
					}).catch(error => {
						this.$message.error(error)
					})
				}).catch(() => {
			
				})
			},
		}
	}
</script>

<style scoped>

</style>
